import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/baseinfobenefit/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getOptionList = (current, size, params) => request({
  url: '/api/mcc-staff/staffBenefit/benefitList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getLevelOption = (params) => request({
  url: '/api/mcc-staff/staffBenefitLevel/getAll',
  method: 'get',
  params: {
    ...params,

  },
})
const saveLevelOption = (data) => request({
  url: '/api/mcc-staff/staffBenefitLevel/save',
  method: 'post',
  data: data
})
const getPage = (current, size, params) => request({
  url: '/api/mcc-staff/staffBenefit/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const BenefitDownload = (params) => request({
  url: '/api/mcc-staff/baseinfobenefit/export',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,

  },
})
const getBenefitDetail = params => request({
  url: '/api/mcc-staff/staffBenefit/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const add = params => request({
  url: '/api/mcc-staff/baseinfobenefit/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/baseinfobenefit/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const submit = params => request({
  url: '/api/mcc-staff/baseinfobenefit/submit',
  method: 'post',
  data: params,
})

const update = params => request({
  url: '/api/mcc-staff/baseinfobenefit/update',
  method: 'post',
  data: params,
})

const updateList = params => request({
  url: '/api/mcc-staff/baseinfobenefit/updateList',
  method: 'post',
  data: params,
})

const benefitUpdate = params => request({
  url: '/api/mcc-staff/baseinfobenefit/benefitUpdate',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/baseinfobenefit/remove',
  method: 'post',
  params: {
    ids,
  },
})

const downLoadExcel = params => request({
  url: '/api/mcc-staff/staffBenefit/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    size: -1,
    ...params,
  },
})

export default {
  getList,
  getOptionList,
  getPage,
  getBenefitDetail,
  add,
  detail,
  update,
  remove,
  updateList,
  benefitUpdate,
  submit,
  downLoadExcel,
  BenefitDownload,
  getLevelOption,
  saveLevelOption
};
